import * as $ from 'jquery';
import Popper from 'popper.js';
import Tether from 'tether';
window.jQuery = window.$ = $;
window.Popper = Popper;
window.Tether = Tether;


// WEBPACK FOOTER //
// ./src/assets/js/jquery.js